// Mock data for Io cambio insieme political party website

export const partyInfo = {
  name: "Io cambio insieme",
  tagline: "Costruiamo insieme un futuro migliore per Spresiano",
  mission: "Un movimento per il cambiamento ambientale e sociale, dove ogni voce conta e ogni azione fa la differenza."
};

export const heroData = {
  title: "Io cambio insieme",
  subtitle: "Costruiamo insieme un futuro migliore per Spresiano",
  description: "Un movimento per il cambiamento ambientale e sociale, dove ogni voce conta e ogni azione fa la differenza.",
  image: "/images/hero/hero.webp",
  cta: {
    primary: "Prossimi Appuntamenti",
    secondary: "Scopri di più"
  }
};

export const aboutData = {
  title: "Chi Siamo",
  description: "La lista civica IO CAMBIO INSIEME annuncia la propria partecipazione alle elezioni amministrative del Comune di Spresiano del 24 e 25 maggio 2026.\n\nCandidato sindaco sarà Andrea Dalla Villa, quarantenne, già consigliere comunale nei gruppi di minoranza e da sempre molto attivo nell'associazionismo. Il progetto nasce dall'impegno di tante cittadine e cittadini provenienti dalla società civile, con diverse esperienze e sensibilità, accomunati dal desiderio di un'amministrazione nuova, capace di ascoltare, coinvolgere e valorizzare le energie della comunità. Inoltre, la lista è sostenuta da AVS - Alleanza Verdi e Sinistra, Italia Viva, Movimento 5 Stelle, Partito Democratico.\n\nTra le priorità di IO CAMBIO INSIEME ci sono: il coinvolgimento dei cittadini come fondamento di ogni scelta amministrativa particolarmente significativa, la cura del nostro territorio come strumento per restituire sicurezza e fruibilità agli spazi pubblici; la tutela dell'ambiente e della salute come investimento sul futuro; la costruzione di un nuovo senso di comunità.",
  vision: "",
  values: [
    {
      icon: "Leaf",
      title: "Sostenibilità Ambientale",
      description: "Protezione dell'ambiente e transizione verso energie rinnovabili"
    },
    {
      icon: "Users",
      title: "Giustizia Sociale",
      description: "Equità, inclusione e diritti per tutti i cittadini"
    },
    {
      icon: "Heart",
      title: "Comunità",
      description: "Rafforzamento del tessuto sociale e partecipazione attiva"
    },
    {
      icon: "Target",
      title: "Trasparenza",
      description: "Governance aperta e responsabilità verso i cittadini"
    }
  ]
};

export const policiesData = {
  title: "Le Nostre Politiche",
  subtitle: "Un programma concreto per il cambiamento",
  policies: [
    {
      id: 1,
      icon: "Wind",
      title: "Decoro Urbano e Nuovi Spazi",
      description: "Il decoro urbano rappresenta una priorità. Un paese pulito, ordinato e ben mantenuto non è solo più bello, ma contribuisce al nostro benessere.",
      image: "/images/policies/progetto-1.webp",
      details: []
    },
    {
      id: 2,
      icon: "TreePine",
      title: "Ambiente e Sviluppo",
      description: "Tutela dell'ambiente promuovendo lo sviluppo economico sostenibile e tutelando i posti di lavoro, con pianificazione degli interventi sul lungo periodo.",
      image: "/images/policies/progetto-10.webp",
      details: [
        "Contenimento dei costi energetici",
        "Tutela delle componenti ambientali fondamentali per la salute",
        "Promozione delle attività commerciali",
        "Valorizzazione della posizione strategica del comune"
      ]
    },
    {
      id: 3,
      icon: "GraduationCap",
      title: "Sicurezza e Viabilità",
      description: "Sicurezza attraverso la prevenzione, superando gli atteggiamenti che generano paura, promuovendo la cultura, l'educazione al rispetto delle regole e intervenendo con fermezza se violate.",
      image: "/images/policies/sicurezza.webp",
      details: [
        "Un paese con spazi comuni più vissuti",
        "Un paese sicuro per ciclisti e pedoni",
        "Interventi per risolvere le criticità di sicurezza stradale"
      ]
    },
    {
      id: 4,
      icon: "HeartPulse",
      title: "Sanità Accessibile",
      description: "La salute non solo come fondamentale diritto dell'individuo ma anche come interesse della comunità.",
      image: "/images/policies/progetto-11.webp",
      details: [
        "Potenziamento dei servizi socio sanitari locali",
        "Promozione dello sport e sostegno alle associazioni sportive",
        "Maggiore dialogo con ULSS e medici per migliorare l'accesso a cure e strutture"
      ]
    },
    {
      id: 5,
      icon: "Home",
      title: "Partecipazione e Condivisione",
      description: "Rendere i cittadini e le associazioni partecipi dell'amministrazione del Comune per favorire il dialogo e migliorare il livello del dibattito pubblico.",
      image: "/images/policies/progetto-8.webp",
      details: [
        "Interventi per favorire la condivisione",
        "Adesione a Comuni d'Europa",
        "Iniziative di gemellaggio solidale con aree in conflitto"
      ]
    },
    {
      id: 6,
      icon: "Scale",
      title: "Identità e Comunità",
      description: "Promozione della memoria storica, per conservare le nostre radici e al contempo costruire un nuovo senso di comunità.",
      image: "/images/policies/progetto-5.webp",
      details: [
        "Riorganizzazione e rivalutazione dei luoghi simbolici della comunità",
        "Comprensione del disagio giovanile e percorsi di prevenzione e recupero",
        "Più mediazioni culturali per una socialità aperta e condivisa"
      ]
    }
  ]
};

export const leadershipData = {
  title: "La Nostra Squadra",
  subtitle: "Un team dedicato al cambiamento",
  leaders: [
    {
      id: 1,
      name: "Andrea Dalla Villa",
      role: "Candidato Sindaco",
      image: "/images/team/andrea-dalla-villa.webp",
      bio: "40 anni, Spresiano. Laurea magistrale in storia dell'arte, attività professionale in campo turistico, attivo in gruppi parrocchiali e già consigliere comunale."
    },
    {
      id: 2,
      name: "Lisa Benini",
      role: "Candidata Consigliera",
      image: "/images/team/lisa-benini.webp",
      bio: "48 anni, laureata in scienze dell'architettura allo IUAV, libera professionista. Interior designer impegnata nell'ambito culturale e sociale, appassionata attivista per i diritti delle donne e per una genitorialità consapevole e condivisa."
    },
    {
      id: 3,
      name: "Valentina Bertelli",
      role: "Candidata Consigliera",
      image: "/images/team/valentina-bertelli.webp",
      bio: "42 anni, Calessani. Docente. Sono una persona estroversa e dinamica, qualità che mi permettono di ascoltare le persone e di lavorare insieme per trovare soluzioni concrete. Attiva in ambito sociale e culturale."
    },
    {
      id: 4,
      name: "Chiara Breda",
      role: "Candidata Consigliera",
      image: "/images/team/chiara-breda.webp",
      bio: "55 anni, Spresiano. Docente di matematica e scienze, laureata in biologia. Attiva in gruppi ambientali e sociali."
    },
    {
      id: 5,
      name: "Flavio Bullo",
      role: "Candidato Consigliere",
      image: "/images/team/flavio-bullo.webp",
      bio: "66 anni, Spresiano. Designer d'interni e progettista, con varie esperienze manageriali, attivo in ambito sociale e civico."
    },
    {
      id: 6,
      name: "Silvana Carchidi",
      role: "Candidata Consigliera",
      image: "/images/team/silvana-carchidi.webp",
      bio: "66 anni, Lovadina. Insegnante in pensione, ambientalista impegnata, credo che un mondo migliore sia possibile."
    },
    {
      id: 7,
      name: "Enrico Figini",
      role: "Candidato Consigliere",
      image: "/images/team/enrico-figini.webp",
      bio: "58 anni, Spresiano. Commerciale estero, laurea in scienze politiche, sposato, due figli. Storia ed Europa le mie passioni."
    },
    {
      id: 8,
      name: "Christian Fornasier",
      role: "Candidato Consigliere",
      image: "/images/team/christian-fornasier.webp",
      bio: "52 anni, Lovadina. Avvocato, attivo in ambito culturale."
    },
    {
      id: 9,
      name: "Isabella Gnes",
      role: "Candidata Consigliera",
      image: "/images/team/isabella-gnes.webp",
      bio: "68 anni, Spresiano. Già addetta al commercio estero in una azienda privata, volontaria animalista, sensibilità ecologica."
    },
    {
      id: 10,
      name: "Marco Sandy Menegazzo",
      role: "Candidato Consigliere",
      image: "/images/team/marco-menegazzo.webp",
      bio: "56 anni, Spresiano. Addetto alla logistica, appassionato di musica e curioso verso tutte le forme d'arte, sento una forte connessione con la natura e l'ambiente."
    },
    {
      id: 11,
      name: "Timoteo Rizzotti",
      role: "Candidato Consigliere",
      image: "/images/team/timoteo-rizzotti.webp",
      bio: "19 anni, Spresiano. Studente di ingegneria meccanica, scout e sportivo."
    },
    {
      id: 12,
      name: "Roberto Simonetti",
      role: "Candidato Consigliere",
      image: "/images/team/roberto-simonetti.webp",
      bio: "76 anni, Spresiano. Medico di famiglia dal 1980 al 2018. Attivo nel volontariato, referente ANPI per Spresiano e Villorba."
    },
    {
      id: 13,
      name: "Alessandra Vescovo",
      role: "Candidata Consigliera",
      image: "/images/team/alessandra-vescovo.webp",
      bio: "33 anni, Visnadello. Consulente per la sostenibilità nelle aziende, addestratrice cinofila, amante della natura."
    },
    {
      id: 14,
      name: "Augustino Villanova",
      role: "Candidato Consigliere",
      image: "/images/team/augustino-villanova.webp",
      bio: "66 anni, Visnadello. Ex assistente tecnico in Telecom, mi occupo da sempre di ambiente, volontariato, musica e manifestazioni varie."
    },
    {
      id: 15,
      name: "Antonio Zandonadi",
      role: "Candidato Consigliere",
      image: "/images/team/antonio-zandonadi.webp",
      bio: "60 anni, Spresiano. Auditor, certificatore qualità, attivo nel settore sociale e ambientale."
    }
  ]
};

export const newsData = {
  title: "Prossimi Appuntamenti",
  subtitle: "Partecipa ai nostri eventi",
  articles: [
    {
      id: 1,
      title: "Presentazione della nostra lista",
      excerpt: "Vieni a conoscere il nostro programma e i candidati. Un'occasione per dialogare e condividere idee per il futuro del nostro territorio.",
      date: "Mercoledì 29 Aprile 2026",
      time: "ore 20:45",
      location: "Centro sociale a Spresiano",
      mapsLink: "https://maps.app.goo.gl/5Dq1N2bqRFVNUmkW6",
      category: "Evento",
      image: "/images/events/event-1.webp"
    },
    {
      id: 2,
      title: "Presentazione del programma",
      excerpt: "In questa serata la presentazione sarà in particolare accentuata sul programma. Vieni a conoscere le nostre proposte concrete per il territorio.",
      date: "Venerdì 8 Maggio 2026",
      time: "ore 20:45",
      location: "Sala civica della scuola elementare Visnadello",
      mapsLink: "https://maps.app.goo.gl/Lf9PVhVtNrGsYfM57",
      category: "Evento",
      image: "/images/events/event-2.webp"
    },
    {
      id: 3,
      title: "Presentazione del programma",
      excerpt: "In questa serata la presentazione sarà in particolare accentuata sul programma. Un'occasione per discutere insieme delle priorità per il nostro comune.",
      date: "Venerdì 15 Maggio 2026",
      time: "ore 20:45",
      location: "Centro giochi Lovadina",
      mapsLink: "https://maps.app.goo.gl/W8F379k8jtk4ZFhNA",
      category: "Evento",
      image: "/images/events/event-3.webp"
    }
  ]
};

export const contactData = {
  title: "Unisciti al Cambiamento",
  subtitle: "Ogni voce conta, ogni azione fa la differenza",
  options: [
    {
      icon: "UserPlus",
      title: "Diventa Membro",
      description: "Iscriviti al nostro movimento e partecipa attivamente alle decisioni."
    },
    {
      icon: "HandHeart",
      title: "Fai Volontariato",
      description: "Contribuisci con il tuo tempo e le tue competenze per costruire il cambiamento."
    },
    {
      icon: "Mail",
      title: "Newsletter",
      description: "Ricevi aggiornamenti sulle nostre iniziative e eventi direttamente nella tua casella."
    }
  ],
  office: {
    title: "La Nostra Sede",
    address: "Via del Cambiamento 25",
    city: "00100 Roma, Italia",
    phone: "+39 06 1234 5678",
    email: "info@iocambioinsieme.it"
  }
};

export const footerData = {
  description: "Un movimento politico per un futuro sostenibile e giusto.",
  sections: [
    {
      title: "Il Movimento",
      links: [
        { label: "Chi Siamo", href: "#about" },
        { label: "Le Nostre Politiche", href: "#policies" },
        { label: "La Nostra Squadra", href: "#leadership" },
        { label: "Eventi", href: "#news" }
      ]
    }
  ],
  social: []
};
